import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../UserContext';
import { useNavigate, generatePath } from 'react-router-dom';
import { useApi } from '../ApiContext';
import LoadingSpinner from '../components/LoadingSpinner';
import Container from '../components/Container';
import Heading2 from '../components/Heading2';

const AddPaymentCardScreen: React.FC = () => {
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPaymentForm = async () => {
      setIsLoading(true);

      const { customer_id, provider_id, billingInfo } = userContext?.userData || {};

      if (!customer_id || !provider_id || !billingInfo) {
        setIsLoading(false);
        navigate('/');
        return;
      }

      const path = generatePath('/confirm-appointment');
      const redirectUrl = `${window.location.origin}${window.location.pathname}#${path}`;

      const { data, error } = await api.client.getPaymentFormUrl({
        customer_id,
        provider_id,
        redirect_uri: redirectUrl,
        billing_info: billingInfo,
      });

      setIsLoading(false);

      if (error) {
        setError(`Error getting payment form URL (Request ID: ${error.requestId})`);
        return;
      }

      if (data?.url) {
        window.location.href = data.url;
      } else {
        setError('There was a problem getting the payment form URL');
      }
    };
    fetchPaymentForm();
  }, []);

  return (
    <Container>
      <Heading2>Enter Payment Details</Heading2>
      <p className="text-gray-700 mb-6 text-center">Our billing process is fully secure. 🔒</p>
      <div className="flex justify-center mt-8">{isLoading && <LoadingSpinner />}</div>
      <div role="alert" aria-live="assertive" className="flex justify-center mt-8">
        {error && <p className="text-red-500 text-center">{error}</p>}
      </div>
    </Container>
  );
};

export default AddPaymentCardScreen;
